<template>
  <div>
    <material-button
      class="d-none"
      data-bs-toggle="modal"
      data-bs-target="#modalDeliveryChargeTiers"
      id="show-modal-delivery-charge-tiers"
    ></material-button>
    <div class="modal fade" id="modalDeliveryChargeTiers" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Delivery Charges By Distance</h5>
            <i
              style="cursor: pointer"
              class="material-icons btn-close-modal justify-content-end"
              data-bs-dismiss="modal"
              aria-label="Close"
              >clear</i
            >
          </div>
          <div class="modal-body">
            <div v-if="loading" class="text-center py-3">Loading...</div>
            <template v-else>
              <table class="table align-middle charge-tier-table">
                <thead>
                  <tr>
                    <th></th>
                    <th>Distance (&gt; km)</th>
                    <th>Charge ($)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(tier, index) in tiers" :key="index">
                    <td>
                      <i
                        class="material-icons text-danger cursor-pointer"
                        title="Delete row"
                        @click="tiers.splice(index, 1)"
                        >delete</i
                      >
                    </td>
                    <td><input type="number" min="0" step="0.1" class="form-control" v-model="tier.distance_km" /></td>
                    <td><input type="number" min="0" step="0.01" class="form-control" v-model="tier.charge" /></td>
                  </tr>
                  <tr v-if="tiers.length == 0">
                    <td colspan="3" class="text-center fs-14">No distance rows yet.</td>
                  </tr>
                </tbody>
              </table>
              <div class="fs-14">
                Distance is measured in a straight line from the store to the customer's postal code.
                The highest row it passes applies; closer than every row, the Delivery Fee item price applies.
              </div>
            </template>
            <div v-if="error" class="text-danger fs-14 mt-2">{{ error }}</div>
          </div>
          <div class="modal-footer justify-content-between">
            <material-button class="btn btn-sm btn-background" :disabled="loading" @click="tiers.push({ distance_km: '', charge: '' })">Add Row</material-button>
            <material-button class="btn btn-sm btn-background" :disabled="loading || saving" @click="save">Save</material-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MaterialButton from "@/components/MaterialButton.vue";
import SettingStoreService from "../services/settingStore.service";

// M986 follow-up: delivery charge by distance, copied from iMakan. Saving replaces the list.
export default {
  name: "ModalDeliveryChargeTiers",
  components: { MaterialButton },
  props: {
    branchId: { type: [Number, String], default: 0 },
  },
  emits: ["saved"],
  data() {
    return { tiers: [], loading: false, saving: false, error: "" };
  },
  methods: {
    open() {
      this.error = "";
      this.loading = true;
      document.getElementById("show-modal-delivery-charge-tiers").click();
      SettingStoreService.getDeliveryChargeTiers(this.branchId).then(
        (response) => {
          this.loading = false;
          if (response.data.result.isSuccess) {
            this.tiers = response.data.data.tiers.map((tier) => ({ ...tier }));
          } else {
            this.error = response.data.result.message;
          }
        },
        (error) => {
          this.loading = false;
          this.error = error.message;
        }
      );
    },
    save() {
      this.error = "";
      this.saving = true;
      SettingStoreService.saveDeliveryChargeTiers({ branch_id: this.branchId, tiers: this.tiers }).then(
        (response) => {
          this.saving = false;
          if (response.data.result.isSuccess) {
            this.tiers = response.data.data.tiers.map((tier) => ({ ...tier }));
            document.querySelector("#modalDeliveryChargeTiers .btn-close-modal").click();
            this.$emit("saved");
          } else {
            this.error = response.data.result.message;
          }
        },
        (error) => {
          this.saving = false;
          this.error = error.message;
        }
      );
    },
  },
};
</script>

<style scoped>
.charge-tier-table th {
  font-size: 13px;
  white-space: nowrap;
}
.cursor-pointer {
  cursor: pointer;
}
</style>
